<!--
 * @Description: 
 * @Version: 2.0
 * @Author: Zed
 * @Date: 2020-10-10 13:47:16
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-03-15 14:59:35
-->
<template>
    <div v-if="false" style="background-color: #2D2D2D">
        <div class="footerBox ch-container">
            <div class="copyrightBox">
            </div>
        </div>
    </div>
</template>
<script>
import announcement from "@/api/announcement/announcement"
export default {
    created() {
        // this.queryCompanyProfile(window.location.href);
    },
    data() {
        return {
            companyDomain: null,
            companyName: null,
            recordLink: null,
            recordNumber: null,
            // announceList: [{
            //     name: '免责声明',
            //     path: ''
            // }, {
            //     name: '法律声明',
            //     path: ''
            // }, {
            //     name: '隐私政策',
            //     path: ''
            // }, {
            //     name: '友情链接',
            //     path: ''
            // }, {
            //     name: '意见反馈',
            //     path: ''
            // }]
        }

    },
    methods: {
        toPage(){
            window.open("https://beian.miit.gov.cn/","_blank")
        },
        onAgree() {
            this.$emit("agree");
        },
        queryCompanyProfile(url) {
            announcement.queryCompanyProfile({
                companyDomain: url
            }).then(
                res => {
                    if (res.code === 200) {
                        this.companyName = res.data.companyName
                        var link = document.querySelector("link[rel*='icon']") || document.createElemen('link');
                        link.type = 'image/x-icon';
                        link.rel = 'shortcut icon';
                        link.href = res.data.logo;
                        document.getElementsByTagName('head')[0].appendChild(link);
                        this.recordNumber = res.data.recordNumber
                        if (res.data.companyDomain.indexOf('http://') > -1) {
                            this.companyDomain = res.data.companyDomain;
                        } else {
                            this.companyDomain = 'http://' + res.data.companyDomain;
                        }
                        if (res.data.recordLink.indexOf('http://') > -1) {
                            this.recordLink = res.data.recordLink;
                        } else {
                            this.recordLink = 'http://' + res.data.recordLink;
                        }


                    }
                }
            )
        },
    },
};
</script>

<style lang="less" scoped>
.footer-box {
    background-color: #ffffff;
    margin-top: 20px;
    padding: 5px 0;
}

.copyright {
    text-align: center;
    color: #222222;
    font-size: 14px;
}

.footerBox {
    color: #818181;
    padding-bottom: 15px;
    padding-top: 2px;
    font-size: 12px;
    .el-row {
        margin: 0 20px;
        padding: 0 0 50px;
        // border-bottom: 1px solid #818181;
    }
}

.copyrightBox {
    /* display: flex; */
    margin: 10px 20px 0;
    text-align: center;
    /* position: fixed;
    bottom: 10%; */
    >div {
        border-right: 1px solid #818181;
        padding: 0 20px;
    }

    div:last-of-type {
        border: 0;
    }

    div:first-of-type {
        padding-left: 0;
    }

}
.concatItem, .announceItem{
    cursor: pointer;
}
</style>